import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        projectCode: null, // 项目代码
        projectName: null, // 工程名称
        placeCodeName: null, // 建设地点
        placeCodeDetail: null, // 建设地点详情
        scaleContent: null, // 建设规模及内容
        divisionCodeName: null, // 所属行政区划
        projectNatureName: null, // 建设性质
      },
      formConfigList : [
        {
          label: "项目代码：",
          value: "projectCode",
          type: "input",
          disabled: true,
        },
        {
          label: "工程名称：",
          value: "projectName",
          type: "input",
          disabled: true,
        },
        {
          label: "建设地点：",
          value: "placeCodeName",
          type: "input",
          disabled: true,
        },
        {
          label: "建设地点详情：",
          value: "placeCodeDetail",
          type: "input",
          disabled: true,
        },
        {
          label: "建设规模及内容：",
          value: "scaleContent",
          type: "input",
          disabled: true,
        },
        {
          label: "所属行政区划：",
          value: "divisionCodeName",
          type: "input",
          disabled: true,
        },
        {
          label: "建设性质：",
          value: "projectNatureName",
          type: "input",
          disabled: true,
        }
      ],

    }
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {

  }
}